import { noop } from 'lodash';
import { ReactNode, createContext, useContext, useState } from 'react';

import { IBaseParams } from '@interfaces/IBaseParam';
import { IMetaData } from '@interfaces/IBaseResponse';
import { actionGetStockAlert } from '@libraries/api/inventory/inventory.function';
import { IStockAlert } from '@libraries/api/inventory/inventory.types';
import { useAuth } from './useAuth';

interface IUseAlert {
  refetch: () => void;
  alerts?: IStockAlert[];
  meta?: IMetaData;
  isLoading?: boolean;
  params?: IBaseParams;
  setParams?: (params: IBaseParams) => void;
}

const AlertContext = createContext<IUseAlert>({
  alerts: null,
  refetch: noop,
  isLoading: false,
  params: { page: 1, length: 5 },
  setParams: noop,
});

type TUseAlert = {
  children: ReactNode;
};

export const AlertProvider: React.FC<TUseAlert> = ({ children }) => {
  const { isAuth } = useAuth();
  const [params, setParams] = useState<IBaseParams>({ page: 1, length: 5 });
  const {
    data: alerts,
    isLoading,
    refetch,
  } = actionGetStockAlert(params, isAuth);
  const value = {
    isLoading,
    alerts: alerts?.data,
    refetch,
    meta: alerts?.metadata,
    params,
    setParams,
  };

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
};

export const useStockAlert = (): IUseAlert => useContext(AlertContext);
